import axios from "axios";
import { getAuthorizationHeader } from "./auth";

const baseUrl = `${
  process.env.REACT_APP_API_BASE_URL || "https://api-ma.aiottech.site"
}`.replace(/\/?$/, "/");

const unwrapResponse = (response) => {
  if (response.status === 204) return true;
  if (response.data && Object.prototype.hasOwnProperty.call(response.data, "content")) {
    return response.data.content;
  }
  return response.data;
};

const toMessageList = (value) => {
  if (!value) return [];
  if (typeof value === "string") return [value];
  if (Array.isArray(value)) return value.flatMap(toMessageList);
  if (typeof value !== "object") return [String(value)];

  const messageKeys = ["detail", "message", "msg", "title", "description", "error"];
  const directMessages = messageKeys.flatMap((key) => toMessageList(value[key]));
  if (directMessages.length > 0) return directMessages;

  return Object.entries(value).flatMap(([key, nestedValue]) =>
    toMessageList(nestedValue).map((message) => `${key}: ${message}`)
  );
};

export const getApiErrorDetails = (error) => {
  const response = error?.response;
  const data = response?.data;
  const messages = toMessageList(data);
  const fallbackMessage =
    error?.message || "Không thể kết nối tới backend. Vui lòng thử lại.";

  return {
    status: response?.status,
    statusText: response?.statusText,
    message: messages[0] || fallbackMessage,
    messages: messages.length > 0 ? messages : [fallbackMessage],
    data,
  };
};

const getApi = async (endpoint) => {
  try {
    const response = await axios.get(baseUrl + endpoint, {
      headers: getAuthorizationHeader(),
    });
    return unwrapResponse(response);
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const postApi = async (endpoint, data) => {
  try {
    const response = await axios.post(baseUrl + endpoint, data, {
      headers: getAuthorizationHeader(),
    });
    return unwrapResponse(response);
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const putApi = async (endpoint, data) => {
  try {
    const response = await axios.put(baseUrl + endpoint, data, {
      headers: getAuthorizationHeader(),
    });
    return unwrapResponse(response);
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const deleteApi = async (endpoint) => {
  try {
    const response = await axios.delete(baseUrl + endpoint, {
      headers: getAuthorizationHeader(),
    });
    return unwrapResponse(response);
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export { getApi, postApi, putApi, deleteApi };
